import React from "react";
import Hero from "./Hero";
import { Stack } from "@mui/material";
import LiveProjects from "./LiveProjects";
import Skills from "./Skills";
import WhoAmI from "./WhoAmI";
import ContactUsForm from "./ContactMe";
import ScrollNavigation from "./ScrollNavigation";
import SeoHelmet from "../../../Components/SeoHelmet";

export default function Home() {
  return (
    <>
      <SeoHelmet />
      <Stack sx={{ position: "relative" }}>
        <Hero />
        <LiveProjects />
        <Skills />
        <WhoAmI />
        <ContactUsForm />
        <ScrollNavigation />
      </Stack>
    </>
  );
}
